import { AxiosResponse } from 'axios';
import React from 'react';
import { API_ENDPOINT } from '../../constants/api-endpoints';
import { useApiService } from '../../hooks/useApiService';
import { useHandleErrorService } from '../../hooks/useHandleErrorService';
import { dateUtil } from '../../utility/dateUtil';

export const useDisplayService = () => {

    const { fetchPublicRequest } = useApiService();
    const { handleError } = useHandleErrorService();

    const fetchTrips = async (
        updateState: React.Dispatch<React.SetStateAction<any>>,
        ghat: string
    ) => {
        try {
            const response: AxiosResponse = await fetchPublicRequest(
                API_ENDPOINT.TRIPS_BY_ORIGIN,
                {
                    ghatId: ghat,
                    tripDate: dateUtil.formatDate(new Date().toISOString())
                }
            );

            const { object } = response.data;
            updateState(object);
        } catch (error) {
            handleError(error);
        }
    }

    return {
        fetchTrips
    }
}
